export default __webpack_public_path__ + "static/media/p3-15.ef2d1671.png";